import React from 'react'
import { useSelector } from 'react-redux'
import PreferredIcon from 'transfix-icons/build/PreferredIcon'
import { Card } from 'transfix-ui/components/Card'
import { ExpandableText } from 'transfix-ui/components/ExpandableText'
import { IDetentionShipment } from 'apps/detention-review/utils/types'

interface ICarrierInformationStore {
  shipmentData: ICarrierInformationState
}
interface ICarrierInformationState {
  shipment: IDetentionShipment
}

export const CarrierInformation = () => {
  const state = useSelector<ICarrierInformationStore, ICarrierInformationState>(
    ({ shipmentData: { shipment } }) => ({ shipment })
  )
  const {
    shipment: {
      contactPreferenceAttributes: { carrierContactInstructions },
      info: {
        carrierId,
        carrierIsTrusted,
        carrierName,
        carrierSpecificInfo,
        dispatcherEmail,
        dispatcherName,
        dispatcherParentUserId,
        dispatcherPhone,
        driverName,
        driverParentUserId,
        driverPhone,
        opsRepName,
        opsRepParentUserId,
      },
    },
  } = state
  return (
    <div className='col-xs-12 col-md-12'>
      <Card title='Carrier Contact Information'>
        <div className='col-md-6'>
          <p>
            <a href={`${__ROOT__}/carriers/${carrierId}`} target='_blank' rel='noopener noreferrer'>
              {carrierName}&nbsp;
            </a>
            {carrierIsTrusted && <PreferredIcon />}
          </p>
          <div className='pv5'>
            <ExpandableText
              text={carrierSpecificInfo}
              label='Instructions for Contacting Carrier'
              tall
            />
          </div>
          <p className='text-secondary'>Additional Instructions</p>
          <div>{carrierContactInstructions}</div>
        </div>
        <div className='col-md-6'>
          <strong>Driver</strong>
          <p className='text-secondary'>
            Name:{' '}
            <a
              href={`${__ROOT__}/users/${driverParentUserId}`}
              target='_blank'
              rel='noopener noreferrer'>
              {driverName}
            </a>
          </p>
          <p className='text-secondary'>Phone: {driverPhone}</p>
        </div>
        <div className='col-md-6 pt5'>
          <strong>Dispatcher</strong>
          <p className='text-secondary'>
            Name:{' '}
            <a
              href={`${__ROOT__}/users/${dispatcherParentUserId}`}
              target='_blank'
              rel='noopener noreferrer'>
              {dispatcherName}
            </a>
          </p>
          <p className='text-secondary'>Phone: {dispatcherPhone}</p>
          <p className='text-secondary'>Email: {dispatcherEmail}</p>
        </div>
        <div className='col-md-6 pt5 fr'>
          <strong>Carrier Manager</strong>
          <p className='text-secondary'>
            <a
              href={`${__ROOT__}/users/${opsRepParentUserId}`}
              target='_blank'
              rel='noopener noreferrer'>
              {opsRepName}
            </a>
          </p>
        </div>
      </Card>
    </div>
  )
}
